import { SummaryStatsCard } from '@exam-center/components';
import { useExamCenter } from '@exam-center/exam-center-details';
import { useGetExamCenterProctorRequestsCountQuery } from '@exam-center/graphql';
import { Flex } from '@shared/components';
import { useMemo } from 'react';

export default function ProctorRequestSummaryStatuses() {
  const { examCenter } = useExamCenter();
  const { data, loading: isLoading } = useGetExamCenterProctorRequestsCountQuery({
    variables: {
      getExamCenterProctorRequestsCountInput: {
        examCenterCode: examCenter.code,
      },
    },
    fetchPolicy: 'network-only',
  });

  const { numberOfDraft, numberOfInReview, numberOfRejected } = useMemo(() => {
    const proctorRequestCount =
      data?.ecGetExamCenterProctorRequestsCountByExamCenterCode.proctorRequestCountByStatus;

    return {
      numberOfDraft: proctorRequestCount?.DRAFT ?? 0,
      numberOfInReview: proctorRequestCount?.IN_REVIEW ?? 0,
      numberOfRejected: proctorRequestCount?.REJECTED ?? 0,
    };
  }, [data?.ecGetExamCenterProctorRequestsCountByExamCenterCode]);

  return (
    <Flex sx={(theme) => ({ gap: theme.spacing(4) })}>
      <SummaryStatsCard
        title='แบบร่าง'
        displayValue={`${numberOfDraft} รายการ`}
        loading={isLoading}
        color='info'
      />
      <SummaryStatsCard
        title='อยู่ระหว่างอนุมัติ'
        displayValue={`${numberOfInReview} รายการ`}
        loading={isLoading}
        color='warning'
      />
      <SummaryStatsCard
        title='ไม่อนุมัติ'
        displayValue={`${numberOfRejected} รายการ`}
        loading={isLoading}
        color='error'
      />
    </Flex>
  );
}
